// Подписи схем УЗИ.
//
// В схемах УЗИ (usiFormSchema.js / usiFormSchemasRest.js) русский текст остаётся
// в полях label / title / printTitle / placeholder / heading и служит источником
// правды: из label строится значение, которое пишется в БД, и по нему же
// находятся сохранённые протоколы. Рядом с каждым таким полем лежит
// параллельное поле с языковым ключом (labelKey / titleKey / …Key).
//
// На экран всегда выводится перевод по ключу, а русское значение — только
// запасной вариант, если ключа ещё нет.

export const usiText = (source, field, t) => {
  if (!source) return "";
  const fallback = source[field] ?? "";
  const key = source[`${field}Key`];
  if (!key || typeof t !== "function") return fallback;
  const translated = t(key);
  return translated && translated !== key ? translated : fallback;
};

// Собирает подпись из двух полей, например «ОСА (правая)» нельзя — поэтому
// просто последовательно берём перевод каждого фрагмента.
export const usiTextPart = usiText;
